export interface BadgeProps {
  firstApplication: boolean;
  firstApplicationBadgeChecked: boolean;
}

export const badgeList: BadgeProps = {
  firstApplication: false,
  firstApplicationBadgeChecked: false,
};
